import React from 'react';
import { Presentation } from './pages/Presentation';
export function App() {
  return <Presentation data-id="element-0" />;
}